import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar.component';
import { CalendarModule } from './calendar.module';
import {Islamic} from '@syncfusion/ej2-calendars';


export const /** @type {?} */ IslamicService: ValueProvider = { provide: 'CalendarsIslamic', useValue: Islamic};
/**
 * NgModule definition for the Calendar component with providers.
 */
export class CalendarAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, CalendarModule],
    exports: [
        CalendarModule
    ],
    providers:[
        IslamicService
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CalendarAllModule_tsickle_Closure_declarations() {
/** @type {?} */
CalendarAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
